import { percentToDecimal } from '@calculations/decimal/percent';

import { onPartContributionMarginChange } from '../../calculations/recalculate';
import { validateContributionMargin } from '../../validations/contribution-margin';
import { PriceFieldHandlerParams } from './types';

export function handlePartContributionMarginChange({
  state,
  quoteLineUuid,
  quotePriceUuid,
  value,
  priceStrategyConfigs,
}: PriceFieldHandlerParams) {
  const contributionMarginPercent = validateContributionMargin(state, {
    contributionMargin: value,
    quoteLineUuid,
    quotePriceUuid,
  });

  if (!contributionMarginPercent) {
    return;
  }

  const contributionMargin = percentToDecimal(contributionMarginPercent);

  onPartContributionMarginChange(state, {
    quoteLineUuid,
    quotePriceUuid,
    contributionMargin,
    priceStrategyConfigs,
  });
}

// @NOTE(mrs): Service charges do not have a contribution margin
